
export const LOAD_ROLE_DATA_IN_PROGRESS = "LOAD_ROLE_DATA_IN_PROGRESS";
export const loadRoleDataInProgress = () => ({
  type: LOAD_ROLE_DATA_IN_PROGRESS,
});

export const LOAD_ROLE_DATA_SUCCESS = "LOAD_ROLE_DATA_SUCCESS";
export const loadRoleDataSuccess = (data) => ({
  type: LOAD_ROLE_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_ROLE_DATA_FAILURE = "LOAD_ROLE_DATA_FAILURE";
export const loadRoleDataFailure = () => ({
  type: LOAD_ROLE_DATA_FAILURE,
});

export const OPEN_ROLE_DIALOG = "OPEN_ROLE_DIALOG";
export const openRoleDialog = () => ({
  type: OPEN_ROLE_DIALOG,
});

export const CLOSE_ROLE_DIALOG = "CLOSE_ROLE_DIALOG";
export const closeRoleDialog = () => ({
  type: CLOSE_ROLE_DIALOG,
});

export const ROLE_OPERATION_COMPLETED = "ROLE_OPERATION_COMPLETED";
export const roleOperationCompleted = () => ({
  type: ROLE_OPERATION_COMPLETED,
});